export function hideBodyScroll() {
  document.body.classList.add('no-scroll');
}

export function showBodyScroll() {
  document.body.classList.remove('no-scroll');
}
